import React, { Component } from 'react';
import PropTypes from 'prop-types';
import history from 'utils/history';
import { observer, inject } from 'mobx-react';
import { CurrentUser, Urls } from 'apps/find-designers/propTypes';
import initTypeform from 'utils/initTypeform';
import Filters from './Filters';
import PageLayout from './PageLayout';
import ResultsPane from './ResultsPane';
import { SearchContext } from './SearchContext';

class FindDesignersApp extends Component {
    constructor() {
        super();

        this.handleClear = this.handleClear.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        initTypeform();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            if (!this.props.filterStore.isQuerySet(nextProps.location.search)) {
                this.props.filterStore.setFiltersFromQueryString(nextProps.location.search);
            }
        }
    }

    handleChange(name, value) {
        this.props.filterStore.setValue(name, value);

        if (name === 'keyword') {
            // keyword filter
            history.replace(`/designers/search${this.props.filterStore.currentQueryString}`);
        } else {
            history.push(`/designers/search${this.props.filterStore.currentQueryString}`);
        }
    }

    handleClear(e) {
        const { name, value } = e.target;

        this.props.filterStore.clearFilterOption(name, value);
        history.push(`/designers/search${this.props.filterStore.currentQueryString}`);
    }

    handleReset() {
        this.props.filterStore.reset();
        history.push(`/designers/search${this.props.filterStore.currentQueryString}`);
    }

    layoutChildren() {
        return (
            <div className="row">
                <div className="column small-12 medium-12 normal-3 large-3">
                    <Filters onChange={this.handleChange} />
                </div>
                <div className="column small-12 medium-12 normal-9 large-9">
                    <SearchContext.Provider
                        value={{
                            currentUser: this.props.currentUser,
                            categories: this.props.categories,
                        }}
                    >
                        <ResultsPane
                            filters={this.props.filterStore.activeFilters}
                            searchString={this.props.location.search}
                            storeFront={this.props.filterStore.showStoreFront}
                            onReset={this.handleReset}
                            onClear={this.handleClear}
                            urls={this.props.urls}
                        />
                    </SearchContext.Provider>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.currentUser.isIdentified) {
            return <PageLayout navItems={this.props.navItems}>{this.layoutChildren()}</PageLayout>;
        }

        return (
            <div className="content-body">
                <div className="content-body__inner-1">
                    <div className="content-body__inner-2">{this.layoutChildren()}</div>
                </div>
            </div>
        );
    }
}

FindDesignersApp.propTypes = {
    filterStore: PropTypes.shape({
        setValue: PropTypes.func.isRequired,
        setFiltersFromQueryString: PropTypes.func.isRequired,
        clearFilterOption: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        isQuerySet: PropTypes.func.isRequired,
        currentQueryString: PropTypes.string.isRequired,
        activeFilters: PropTypes.object.isRequired,
        showStoreFront: PropTypes.bool.isRequired,
    }).isRequired,
    urls: Urls.isRequired,
    navItems: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            position: PropTypes.string.isRequired,
            active: PropTypes.string.isRequired,
        })
    ).isRequired,
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
        })
    ).isRequired,
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    currentUser: CurrentUser.isRequired,
};

FindDesignersApp.defaultProps = {
    designers: [],
};

export default inject('filterStore')(observer(FindDesignersApp));



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/FindDesignersApp.jsx